<div class="d-flex flexWrap-wrap">
  <mat-form-field class="col__">
    <mat-label>{{label}}</mat-label>

    <mat-chip-grid #chipList class="mt-0010">
      <mat-chip-row *ngFor="let user of selectedUsers" [disabled]="disabled || requiredUserIds.includes(user.id)" matTooltip="{{user | fullName}}"
        (removed)="onRemoved(user)">{{user | fullName}}
        <button matChipRemove aria-label="Remove {{user | fullName}}" *ngIf="!disabled && !requiredUserIds.includes(user.id)">
          <mat-icon fontSet="far" fontIcon="fa-times"></mat-icon>
        </button>

      </mat-chip-row>

      <input #searchInputElement type="text" matInput [matAutocomplete]="auto" [formControl]="searchControl"
        [matChipInputFor]="chipList" [ngClass]="disabled ? 'd-none pl-0050' : 'pl-0050'">
    </mat-chip-grid>
  </mat-form-field>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelected($event)" [displayWith]="displayWithFn">
    <mat-option class="match d-flex flexWrap-wrap flexJustify-between" *ngFor="let option of filteredResults$ | async"
      [value]="option">
      <div class="match__main">
        <span class="match__name">{{ option.firstName }} {{option.lastName}}</span>
        <span class="match__meta">{{ option.email }}</span>
      </div>
    </mat-option>
  </mat-autocomplete>
</div>
